export default __webpack_public_path__ + "static/media/RF.26711c0d.svg";